import React from "react"
import { Spacer } from "../atoms/Atoms"
import { Section, SingleShorty } from "./Shared"
import L10n from "../../../lib/carrot-l10n"
import { Button } from "../atoms/buttons/Button"
import DefaultMarkdown from "../DefaultMarkdown"
import { useHistory } from "react-router-dom"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const InsuranceDetails = () => {
  const history = useHistory()

  return (
    <Section
      title="Insurance details"
      description={
        <DefaultMarkdown
          source={l`This information will be used to determine how your Carrot benefit 
        is taxed and if a deductible applies.`}
        />
      }
    >
      <SingleShorty>
        <Button onClick={() => history.push("/talk-to-carrot")} outline>
          {l`Contact the Care Team`}
        </Button>
        <Spacer height={0.75} />
      </SingleShorty>
    </Section>
  )
}

export { InsuranceDetails }
